const get = require('lodash/get')

const generateStockTransferOrderItems = (products) => {
  return Object.keys(products).reduce((acc, product) => {
    acc.push({
      sku: product,
      quantity: get(products[product], 'quantity', 0),
      line_reference: ''
    })
    return acc
  }, [])
}

const generateStockTransferOrder = (shipment, locationUuidById) => {
  // Transform the order object as needed
  const items = generateStockTransferOrderItems(shipment.counts)
  const destination = locationUuidById[shipment.destinationId]
  const d = new Date(shipment.createdAt)
  const shipmentDate = d.toISOString().split('T')[0]

  return {
    destination: get(destination, 'code'),
    origin: get(locationUuidById[shipment.originId], 'code'),
    status: shipment.deleted ? 'cancelled' : 'accepted',
    orderId: shipment.shipmentNumber,
    shipmentType: 'stock-transfer',
    shipmentDate,
    items
  }
}

module.exports = generateStockTransferOrder
